// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MoreOutlinedSvg from "@ant-design/icons-svg/es/asn/MoreOutlined";
import AntdIcon from '../components/AntdIcon';

var MoreOutlined = function MoreOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MoreOutlinedSvg
  }));
};

MoreOutlined.displayName = 'MoreOutlined';
export default React.forwardRef(MoreOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MoreOutlined.js
// module id = 1515
// module chunks = 0